import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import type { UploadPsidFileResult } from '@ps/survey-utils';

import { PsidApi } from '../../api/psid/psid.api';

@Injectable({ providedIn: 'root' })
export class PsidService {
  private readonly _api = inject(PsidApi);

  public getAll(
    fromDate: string,
    toDate: string,
    surveyIds: number[],
  ): Observable<string[]> {
    return this._api.getAll(fromDate, toDate, surveyIds);
  }

  public getCounts(
    isExclusion: boolean,
    surveyIds: number[],
    groupingStatuses: number[],
  ): Observable<number> {
    return this._api.getCounts(isExclusion, surveyIds, groupingStatuses);
  }

  public uploadPsidFile(
    surveyId: number,
    file: File,
  ): Observable<UploadPsidFileResult> {
    return this._api.uploadPsidFile(surveyId, file);
  }
}
